import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PartnerService } from 'src/app/services/partner.service';

@Component({
  standalone: false,
  selector: 'app-corporate-deals-add',
  templateUrl: './corporate-deals-add.component.html',
})
export class CorporateDealsAddComponent {
  form: any = {
    partner_id: '',
    corporate_id: '',
    name: '',
    countdown_minutes: '',
    status: 1,
  };
  validationTriggered = false;

  constructor(
    private toaster: ToastrService,
    private router: Router,
    private partnerService: PartnerService,
  ) {}

  submit(): void {
    this.validationTriggered = true;
    if (!this.form.partner_id || !this.form.name || this.form.countdown_minutes === '' || this.form.countdown_minutes === null) {
      this.toaster.error('Please fill in all required fields.');
      return;
    }

    const payload = {
      partner_id: this.form.partner_id,
      corporate_id: this.form.corporate_id === '' ? null : this.form.corporate_id,
      name: this.form.name,
      countdown_minutes: Number(this.form.countdown_minutes),
      status: Number(this.form.status),
    };

    this.partnerService.create(payload).subscribe({
      next: (result) => {
        this.toaster.success('Corporate deal added.');
        this.router.navigate(['/ecomm/corporate-deals', result.data.id]);
      },
      error: (error) => {
        this.toaster.error(error?.error?.message || 'Failed to add corporate deal.');
      },
    });
  }

  onCountdownMinutesInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '');
    this.form.countdown_minutes = digits;
    if (input.value !== digits) {
      input.value = digits;
    }
  }
}
